import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Video blog",
  "description": "",
  "published": "2007-02-18T00:00:00.000Z",
  "redirect_from": ["/blog/video-blog/swizec/284"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred nekaj dnevi sem se odlocil poskusiti video nakladanje in po tem, ko sem danes zjutraj posnel tri nakladascine v petnajstih minutah, sem dokaj preprican, da se bo stvar prijela. Je lazje, boljse in me naredi bolj smesnega. Edino kar manjka je primerek oprsja, saj ljudem to se najbolj ugaja pri takih stvareh, ampak gotovo se da tudi to nekako pridobiti.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      